// @module StellarGrade.ST_Product.ProductDetailsInformation.View
define('StellarGrade.ST_Product.ProductDetails.Information.View', [
    'ProductDetails.Information.View',
    'StellarGrade.ST_Product.ItemDetails.Specifications.View',
    'item_productdetailsinformation.tpl',
    'underscore',
    'jQuery',
], function (
    ProductDetailsInformationView, 
    ItemDetailsSpecificationsView,
    product_details_information_tpl,
     _, 
     $) {
    'use strict';

    return {
        loadModule: function (container) {
            _.extend(ProductDetailsInformationView.prototype, {
                template: product_details_information_tpl,
                events: {
                    'click [data-type="panelButton"]:not(.disabled)': 'handleClick',
                    'keydown [data-type="panelButton"]:not(.disabled)': 'handleKeyDown',
                },

                initialize: _.wrap(ProductDetailsInformationView.prototype.initialize, function (fn) {
                    fn.apply(this, _.toArray(arguments).slice(1));

                    this.on('afterViewRender', function () {
                        this.initTabs();
                    });
                }),

                childViews: {
                    ItemSpecifications: function () {
                        return new ItemDetailsSpecificationsView({
                            application: container,
                            itemID: this.model.getItem().get('internalid'),
                        });
                    },
                },

                computeDetailsArea: _.wrap(ProductDetailsInformationView.prototype.computeDetailsArea, function (fn) {
                    var details = fn.apply(this, _.toArray(arguments).slice(1));
                    for (var i = 0; i < details.length; i++) {
                        if (details[i].name === 'Description') {
                            // Add Youtube Video
                            var videoContent
                            try {
                                videoContent = this.model.getItem().get('custitem_videolink')
                                if (videoContent) {
                                    details[i].isVideoAvailable = true;
                                    var test = getEmbedUrl(videoContent) + '&rel=0modestbranding=1&showinfo=0&enablejsapi=1';
                                    // console.log('test', test)
                                    details[i].videoContent = test;
                                
                                } 
                            } catch (e) {
                                details[i].error = e;
                            }
                        }
                        if (details[i].name === 'Specifications') {
                            details[i].content = [];
                            details[i].isSpecs = true;
                            details[i].isVideoAvailable = false;

                        } else if (details[i].name === 'Download') {
                            details[i].isDownload = true;
                            details[i].isVideoAvailable = false;

                            details[i].title = this.model.getItem().get('displayname');
                            var contentRaw = details[i].content; // content of hyperlink raw is not working
                            var contentFiltered = contentRaw.match(/href="([^"]*)"/);
                            if (contentFiltered && contentFiltered[1]) {
                                var url = contentFiltered[1];
                                details[i].content = url;
                            }
                        }
                    }

                    return details;
                }),
                // Initialize Tab Panels & Buttons
                initTabs: function () {
                    // Collect Tab Panel Elements from DOM
                    this.tabsContainer = this.$el[0].querySelector('.tabs-container');
                    this.tabsList = this.tabsContainer.querySelector('ul');
                    this.tabButtons = this.tabsList.querySelectorAll('a');
                    this.tabPanels = this.tabsContainer.querySelectorAll('.tabs__panels > div');

                    // Set a11Y Attributes
                    this.tabsList.setAttribute('role', 'tablist');
                    var listItems = this.tabsList.querySelectorAll('li');
                    for (var i = 0; i < listItems.length; i++) {
                        listItems[i].setAttribute('role', 'presentation');
                    }

                    // Initialize Tab Buttons & Panels
                    this.tabButtons.forEach(
                        function (tab, index) {
                            tab.setAttribute('role', 'tab');
                            if (index === 0) {
                                tab.setAttribute('aria-selected', 'true');
                            } else {
                                tab.setAttribute('tabindex', '-1');
                                this.tabPanels[index].setAttribute('hidden', '');
                            }
                        }.bind(this)
                    ); // Using .bind(this) to maintain the correct context

                    // Tab Panel a11Y Attributes
                    this.tabPanels.forEach(
                        function (panel) {
                            panel.setAttribute('role', 'tabpanel');
                            panel.setAttribute('tabindex', '0');
                        }.bind(this)
                    );
                },
                switchTab: function (clickedTab) {
                    // Get target panel
                    var activePanelId = clickedTab.getAttribute('data-target');
                    var activePanel = this.tabsContainer.querySelector(activePanelId);

                    // Unselect and Reset tabindex for all buttons
                    this.tabButtons.forEach(
                        function (button) {
                            button.setAttribute('aria-selected', false);
                            button.setAttribute('tabindex', '-1');
                        }.bind(this)
                    );

                    // Hide all panels
                    this.tabPanels.forEach(
                        function (panel) {
                            panel.setAttribute('hidden', true);
                        }.bind(this)
                    );

                    // Show target panel
                    activePanel.removeAttribute('hidden');

                    // Set a11Y attributes for target panel
                    clickedTab.setAttribute('aria-selected', true);
                    clickedTab.setAttribute('tabindex', '0');
                    clickedTab.focus();

                    // console.log('clickedTab', clickedTab);  
                    // console.log('this', this.details[0].isVideoAvailable);  

                    // if (!this.details[0].isVideoAvailable)
                    // this.

                },
                // Tab button keyboard navigation
                moveLeft: function () {
                    var currentTab = document.activeElement;

                    if (!currentTab.parentElement.previousElementSibling) {
                        this.switchTab(this.tabButtons[this.tabButtons.length - 1]);
                    } else {
                        this.switchTab(currentTab.parentElement.previousElementSibling.querySelector('a'));
                    }
                },
                moveRight: function () {
                    var currentTab = document.activeElement;

                    if (!currentTab.parentElement.nextElementSibling) {
                        this.switchTab(this.tabButtons[0]);
                    } else {
                        this.switchTab(currentTab.parentElement.nextElementSibling.querySelector('a'));
                    }
                },
                // Event handler Functions
                handleClick: function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    var clickedTab = e.target.closest('a');
                    if (!clickedTab) return;

                    this.switchTab(clickedTab);
                },
                handleKeyDown: function (e) {
                    switch (e.key) {
                        case 'ArrowLeft':
                            this.moveLeft();
                            break;
                        case 'ArrowRight':
                            this.moveRight();
                            break;
                        case 'Home':
                            this.switchTab(this.tabButtons[0]);
                            break;
                        case 'End':
                            this.switchTab(this.tabButtons[this.tabButtons.length - 1]);
                            break;
                        default:
                            break;
                    }
                },
            });
        },
    };
});

function getEmbedUrl(youtubeUrl) {
    var videoId = youtubeUrl.split("v=")[1];
    if (videoId) {
        let ampersandPosition = videoId.indexOf("&");
        if (ampersandPosition !== -1) {
            videoId = videoId.substring(0, ampersandPosition);
        }
        return `https://www.youtube.com/embed/${videoId}`;
    }

    return youtubeUrl;
}

var example = [
    { 'Industrial Approvals': 'NEMA 4, 4X, IP65* when properly installed, UL/ULc 60950, CE, FCC Class 15, Part B' },
    {
        'Key Switch':
            'Material: Industrial Silicone Rubber/nLife: Greater than 10 million cycles/nTravel: 0.055" (1.4mm)/nActuation Force: 200g (+/- 30g) / 7.05oz (+/- 1.06oz)/nFeedback: Tactile with mechanical snap',
    },
    {
        Power: 'PS/2 Keyboard: 35mA @ 5V (from keyboard Port)/nPS/2 Mouse: 5mA @ 5V (from mouse port)/n* PS2 Current ratings valid only when both keyboard and mouse are connected/nUSB Keyboard / Mouse: 40mA @ 5V from USB port',
    },
    { 'Temperature Range': 'Operating: -20C to +60C (-4F to +140F)/nStorage: -40C to +70C (-40F to +158F)' },
    { Humidity: '100% (when properly installed)' },
    { Shock: '3×11 ms pulses of 50g on each of 3 axes' },
    { Vibration: 'Power Spectral Density: 0.04g/Hz, Frequency Range: 20Hz-2kHz, Duration of Test per Axis: 3 hours' },
    { Dimensions: '(W-H-D) 17.7" x 9.2" x 1.58" (449.6mm x 233.7mm x 40.1mm)' },
    { Weight: 'Unit: 5.25 lbs (2.38 kg)' },
    { Cable: 'Design: 10 Feet (3.05 meters) Single 10\' "Y-Split" Cable with PS/2 Connectors, or Single USB Cable' },
    { Compatibility: 'PS/2: All windows operating systems most Linux/Unix Systems, USB: All windows operating systems, MAC OS and most Linux/Unix Systems' },
    { Warranty: '1 Year limited Warranty Standard' },
    { 'Model Numbers': '5000-PM-FSR-PS/2 (PS/2 Interface)/n5000-PM-FSR-USB (USB Interface)' },
    { Disclaimer: 'Note: Specifications are subject to change without notice.' },
];
